import * as ActionTypes from '../../constants/actiontypes/funecap/dossiers';
import * as Loadings from '../../constants/loadings/funecap/dossiers';
import * as R from 'ramda';
import BackofficeUser from '../../constants/models/backofficeUser';
import { pageLimit } from '../../constants/paginations/paginationLimit';
import toastConf from '../../utils/toasterConfiguration';
import { toast } from 'react-toastify';

const DossiersReducer = (state = {
    isLoading: [],
    items: [],
    isDeletingClient: false,
    resetPasswordPhoneNumber: false,
    nextPage: true,
    totalPages: 0,
    totalRecords: 0,
    currentPage: 0,
}, action) => {
    switch (action.type) {

        case ActionTypes.FETCH_USERS_DOSSIERS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_DOSSIERS)) {
                state.isLoading = state.isLoading.concat(Loadings.FETCHING_DOSSIERS);
            }
            return { ...state };

        case ActionTypes.FETCH_USERS_DOSSIERS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_DOSSIERS);

            //action.data.length < pageLimit
            if ((action.data.pageNumber + 1) === action.data.totalPages) {
                state.nextPage = false;
            } else {
                state.nextPage = true;
            }

            if (state.items) {
                const moreItems = action.data.items.map(user => new BackofficeUser(user));
                state.items = [...moreItems];
            } else {

                state.items = action.data.items.map(user => new BackofficeUser(user));
            }
            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;

            return { ...state };

        case ActionTypes.FETCH_USERS_DOSSIERS_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_DOSSIERS);
            return { ...state };

        case ActionTypes.UPDATE_USERCREATION_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_USERCREATION)) {
                state.isLoading = state.isLoading.concat(Loadings.UPDATING_USERCREATION);
            }
            return { ...state };

        case ActionTypes.UPDATE_USERCREATION_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USERCREATION);
            state.items = state.items.map((item) => {
                if(item.id === action.data.id)
                    return new BackofficeUser(action.data);

                return item;
            })
            toast.success("Le chargé du dossier a été modifié avec succès.", toastConf);
            return { ...state };

        default:
            return state;
    }
};
export default DossiersReducer;